import scores from '../../assets/scores'

export const getSongScore = songIndex => scores[songIndex - 1]
